import { trackPromise } from 'react-promise-tracker';
import { useOperationStore } from '../../../../../../stores/OperationStore';
import { useManifestContextHook } from '../Context/useManifestContextHook';

function GenerateInvoiceHook() {
  const {waybillNo} = useManifestContextHook()
  const InvoiceManifestAction = useOperationStore((state) => state?.InvoiceManifestAction);

  const generateInvoiceHandle = () => {
    trackPromise(InvoiceManifestAction(waybillNo), 'button-click-area')
  }
  return { generateInvoiceHandle }
}

export default GenerateInvoiceHook